module.exports = '1.3.0';



//////////////////
// WEBPACK FOOTER
// ./~/sockjs-client/lib/version.js
// module id = ./node_modules/sockjs-client/lib/version.js
// module chunks = 3